import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  type AddZoneParams,
  type CoverageZone,
} from "../../../domain/entities/coverage";
import { type ZonesDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const addZone = createAsyncThunk<
  CoverageZone,
  AddZoneParams,
  { dispatch: ZonesDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.ADD_ZONE, async (params, { extra }) => {
  return await extra.zonesRepo.addZone(params);
});
